module.exports = __webpack_public_path__ + "img/product-item-bg.75452572.png";